import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.094 17.323a.77.77 0 0 1-.553-.23.786.786 0 0 1 0-1.103L15.99 3.542a.786.786 0 0 1 1.105 0 .786.786 0 0 1 0 1.104L4.646 17.104a.8.8 0 0 1-.552.219m7.468 2.5a.77.77 0 0 1-.552-.23.786.786 0 0 1 0-1.103l1.25-1.25a.786.786 0 0 1 1.104 0 .786.786 0 0 1 0 1.104l-1.25 1.25a.78.78 0 0 1-.552.229m2.803-2.803a.77.77 0 0 1-.553-.228.786.786 0 0 1 0-1.105l2.49-2.49a.786.786 0 0 1 1.104 0 .786.786 0 0 1 0 1.105l-2.49 2.49a.8.8 0 0 1-.551.229'
      fill='#292D32'
    />
    <path
      d='M11.562 23.698c-1.02 0-2.041-.625-3.28-1.865L3.166 16.72c-2.49-2.49-2.48-4.094.03-6.604l6.918-6.917c2.51-2.51 4.114-2.52 6.604-.031l5.114 5.114c2.49 2.49 2.48 4.094-.031 6.604l-6.917 6.917c-1.26 1.26-2.291 1.896-3.323 1.896m1.875-20.833c-.541 0-1.229.448-2.218 1.437L4.302 11.22c-.99.99-1.438 1.677-1.438 2.208 0 .542.417 1.198 1.407 2.188l5.114 5.114c.99.99 1.636 1.406 2.177 1.406h.01c.543 0 1.22-.448 2.21-1.437l6.916-6.917c.99-.99 1.437-1.677 1.437-2.208 0-.542-.416-1.198-1.406-2.188l-5.114-5.114c-.98-.99-1.636-1.406-2.178-1.406'
      fill='#292D32'
    />
    <path
      d='M22.917 23.698H2.084a.787.787 0 0 1-.782-.781c0-.427.354-.782.781-.782h20.834c.427 0 .781.355.781.782a.787.787 0 0 1-.781.78'
      fill='#292D32'
    />
  </svg>
);
export default SVGComponent;
